module.exports = __webpack_public_path__ + "static/adults_loading-bf0995bef4d0179c41c0b873cfac0d05.jpg";